"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var UpgradeProducts = _interopRequireWildcard(require("self-service-api/constants/UpgradeProducts"));

var links = _interopRequireWildcard(require("self-service-api/core/utilities/links"));

var MerchandiseIds = _interopRequireWildcard(require("self-service-api/constants/MerchandiseIds"));

var _GENERAL$SALES_PRO$SA;

var SALES_PRO = UpgradeProducts.SALES_PRO,
    SALES_FREE = UpgradeProducts.SALES_FREE,
    SALES_STARTER = UpgradeProducts.SALES_STARTER,
    SALES_PROFESSIONAL = UpgradeProducts.SALES_PROFESSIONAL,
    SALES_ENTERPRISE = UpgradeProducts.SALES_ENTERPRISE,
    MARKETING_FREE = UpgradeProducts.MARKETING_FREE,
    MARKETING_STARTER = UpgradeProducts.MARKETING_STARTER,
    MARKETING_STARTER_EMAIL = UpgradeProducts.MARKETING_STARTER_EMAIL,
    MARKETING_BASIC = UpgradeProducts.MARKETING_BASIC,
    MARKETING_PRO = UpgradeProducts.MARKETING_PRO,
    MARKETING_ENTERPRISE = UpgradeProducts.MARKETING_ENTERPRISE,
    SERVICE_FREE = UpgradeProducts.SERVICE_FREE,
    SERVICE_STARTER = UpgradeProducts.SERVICE_STARTER,
    SERVICE_PROFESSIONAL = UpgradeProducts.SERVICE_PROFESSIONAL,
    SERVICE_ENTERPRISE = UpgradeProducts.SERVICE_ENTERPRISE,
    STARTER_CONTACTS = UpgradeProducts.STARTER_CONTACTS,
    ADS = UpgradeProducts.ADS,
    ADS_CAPACITY = UpgradeProducts.ADS_CAPACITY,
    WEBSITE = UpgradeProducts.WEBSITE,
    REPORTING = UpgradeProducts.REPORTING,
    DEDICATED_IP = UpgradeProducts.DEDICATED_IP,
    TRANSACTIONAL_EMAIL = UpgradeProducts.TRANSACTIONAL_EMAIL,
    ADDITIONAL_ACCOUNT = UpgradeProducts.ADDITIONAL_ACCOUNT,
    BRAND_DOMAIN = UpgradeProducts.BRAND_DOMAIN,
    WORKFLOWS_ADDON = UpgradeProducts.WORKFLOWS_ADDON,
    LISTS_ADDON = UpgradeProducts.LISTS_ADDON,
    DESIGNATED_TECHNICAL_SUPPORT = UpgradeProducts.DESIGNATED_TECHNICAL_SUPPORT,
    IN_PERSON_TRAINING = UpgradeProducts.IN_PERSON_TRAINING,
    STARTER_KIT = UpgradeProducts.STARTER_KIT,
    SALES_PROFESSIONAL_ONBOARDING = UpgradeProducts.SALES_PROFESSIONAL_ONBOARDING,
    SERVICE_PROFESSIONAL_ONBOARDING = UpgradeProducts.SERVICE_PROFESSIONAL_ONBOARDING,
    INBOUND_CONSULTING_BLOCK = UpgradeProducts.INBOUND_CONSULTING_BLOCK,
    TECHNICAL_CONSULTING_BLOCK = UpgradeProducts.TECHNICAL_CONSULTING_BLOCK,
    GENERAL = UpgradeProducts.GENERAL,
    CRM = UpgradeProducts.CRM,
    CMS = UpgradeProducts.CMS,
    CMS_PROFESSIONAL = UpgradeProducts.CMS_PROFESSIONAL,
    CMS_ENTERPRISE = UpgradeProducts.CMS_ENTERPRISE,
    ENTERPRISE = UpgradeProducts.ENTERPRISE,
    PARTNER_PROGRAM = UpgradeProducts.PARTNER_PROGRAM,
    SUITE_STARTER = UpgradeProducts.SUITE_STARTER,
    SUITE_PROFESSIONAL = UpgradeProducts.SUITE_PROFESSIONAL,
    SUITE_ENTERPRISE = UpgradeProducts.SUITE_ENTERPRISE,
    BUNDLE = UpgradeProducts.BUNDLE,
    TEMPORARY_REMOTE_TOOLS = UpgradeProducts.TEMPORARY_REMOTE_TOOLS,
    MARKETING = UpgradeProducts.MARKETING,
    SALES = UpgradeProducts.SALES,
    SERVICE = UpgradeProducts.SERVICE,
    CUSTOM_SSL = UpgradeProducts.CUSTOM_SSL;

var _default = (_GENERAL$SALES_PRO$SA = {}, (0, _defineProperty2.default)(_GENERAL$SALES_PRO$SA, GENERAL, {
  upgradeLink: links.productsAndAddons,
  merchandiseId: null
}), (0, _defineProperty2.default)(_GENERAL$SALES_PRO$SA, SALES_PRO, {
  upgradeLink: links.salesPricing,
  merchandiseId: MerchandiseIds.PRODUCT_SALES_PRO_LEGACY
}), (0, _defineProperty2.default)(_GENERAL$SALES_PRO$SA, SALES_FREE, {
  upgradeLink: links.salesPricing,
  merchandiseId: MerchandiseIds.PRODUCT_SALES_FREE
}), (0, _defineProperty2.default)(_GENERAL$SALES_PRO$SA, SALES_STARTER, {
  upgradeLink: links.salesPricing,
  merchandiseId: MerchandiseIds.PRODUCT_SALES_STARTER_MAR_2020
}), (0, _defineProperty2.default)(_GENERAL$SALES_PRO$SA, SALES_PROFESSIONAL, {
  upgradeLink: links.salesPricing,
  merchandiseId: MerchandiseIds.PRODUCT_SALES_PROFESSIONAL_NOV_2019
}), (0, _defineProperty2.default)(_GENERAL$SALES_PRO$SA, SALES_ENTERPRISE, {
  upgradeLink: links.salesPricing,
  merchandiseId: MerchandiseIds.PRODUCT_SALES_ENTERPRISE
}), (0, _defineProperty2.default)(_GENERAL$SALES_PRO$SA, MARKETING_FREE, {
  upgradeLink: links.marketingPricing,
  merchandiseId: MerchandiseIds.PRODUCT_MARKETING_FREE
}), (0, _defineProperty2.default)(_GENERAL$SALES_PRO$SA, MARKETING_STARTER, {
  upgradeLink: links.marketingPricing,
  merchandiseId: MerchandiseIds.PRODUCT_MARKETING_STARTER_NOV_2019
}), (0, _defineProperty2.default)(_GENERAL$SALES_PRO$SA, MARKETING_STARTER_EMAIL, {
  upgradeLink: links.marketingPricing,
  merchandiseId: MerchandiseIds.PRODUCT_MARKETING_STARTER_NOV_2019
}), (0, _defineProperty2.default)(_GENERAL$SALES_PRO$SA, MARKETING_BASIC, {
  upgradeLink: links.marketingPricing,
  merchandiseId: MerchandiseIds.PRODUCT_MARKETING_BASIC
}), (0, _defineProperty2.default)(_GENERAL$SALES_PRO$SA, MARKETING_PRO, {
  upgradeLink: links.marketingPricing,
  merchandiseId: MerchandiseIds.PRODUCT_MARKETING_PROFESSIONAL
}), (0, _defineProperty2.default)(_GENERAL$SALES_PRO$SA, MARKETING_ENTERPRISE, {
  upgradeLink: links.marketingPricing,
  merchandiseId: MerchandiseIds.PRODUCT_MARKETING_ENTERPRISE
}), (0, _defineProperty2.default)(_GENERAL$SALES_PRO$SA, SERVICE_FREE, {
  upgradeLink: links.servicePricing,
  merchandiseId: MerchandiseIds.PRODUCT_SERVICE_FREE
}), (0, _defineProperty2.default)(_GENERAL$SALES_PRO$SA, SERVICE_STARTER, {
  upgradeLink: links.servicePricing,
  merchandiseId: MerchandiseIds.PRODUCT_SERVICE_STARTER_MAR_2020
}), (0, _defineProperty2.default)(_GENERAL$SALES_PRO$SA, SERVICE_PROFESSIONAL, {
  upgradeLink: links.servicePricing,
  merchandiseId: MerchandiseIds.PRODUCT_SERVICE_PROFESSIONAL
}), (0, _defineProperty2.default)(_GENERAL$SALES_PRO$SA, SERVICE_ENTERPRISE, {
  upgradeLink: links.servicePricing,
  merchandiseId: MerchandiseIds.PRODUCT_SERVICE_ENTERPRISE
}), (0, _defineProperty2.default)(_GENERAL$SALES_PRO$SA, STARTER_CONTACTS, {
  upgradeLink: links.starterContacts,
  merchandiseId: MerchandiseIds.PRODUCT_MARKETING_STARTER_CONTACTS
}), (0, _defineProperty2.default)(_GENERAL$SALES_PRO$SA, CMS, {
  upgradeLink: links.cmsPricing,
  merchandiseId: MerchandiseIds.PRODUCT_CMS_PROFESSIONAL
}), (0, _defineProperty2.default)(_GENERAL$SALES_PRO$SA, CMS_PROFESSIONAL, {
  upgradeLink: links.cmsPricing,
  merchandiseId: MerchandiseIds.PRODUCT_CMS_PROFESSIONAL
}), (0, _defineProperty2.default)(_GENERAL$SALES_PRO$SA, CMS_ENTERPRISE, {
  upgradeLink: links.cmsPricing,
  merchandiseId: MerchandiseIds.PRODUCT_CMS_ENTERPRISE
}), (0, _defineProperty2.default)(_GENERAL$SALES_PRO$SA, ADS, {
  upgradeLink: links.addonAds,
  merchandiseId: MerchandiseIds.ADDON_ADS
}), (0, _defineProperty2.default)(_GENERAL$SALES_PRO$SA, ADS_CAPACITY, {
  upgradeLink: links.addonAds,
  merchandiseId: MerchandiseIds.ADDON_ADS_CAPACITY
}), (0, _defineProperty2.default)(_GENERAL$SALES_PRO$SA, WEBSITE, {
  upgradeLink: links.addonWebsite,
  merchandiseId: MerchandiseIds.ADDON_WEBSITE_STARTER
}), (0, _defineProperty2.default)(_GENERAL$SALES_PRO$SA, REPORTING, {
  upgradeLink: links.addonReporting,
  merchandiseId: MerchandiseIds.ADDON_REPORTING,
  trialDuration: 10
}), (0, _defineProperty2.default)(_GENERAL$SALES_PRO$SA, DEDICATED_IP, {
  upgradeLink: links.addonDedicatedIp,
  merchandiseId: MerchandiseIds.ADDON_DEDICATED_IP
}), (0, _defineProperty2.default)(_GENERAL$SALES_PRO$SA, TRANSACTIONAL_EMAIL, {
  upgradeLink: links.addonTransactionalEmail,
  merchandiseId: MerchandiseIds.ADDON_TRANSACTIONAL_EMAIL
}), (0, _defineProperty2.default)(_GENERAL$SALES_PRO$SA, ADDITIONAL_ACCOUNT, {
  upgradeLink: links.addonAdditionalPortalLink,
  merchandiseId: null
}), (0, _defineProperty2.default)(_GENERAL$SALES_PRO$SA, BRAND_DOMAIN, {
  upgradeLink: links.addonBrandDomain,
  merchandiseId: MerchandiseIds.ADDON_BRAND_DOMAIN
}), (0, _defineProperty2.default)(_GENERAL$SALES_PRO$SA, WORKFLOWS_ADDON, {
  upgradeLink: links.marketingPricing,
  merchandiseId: MerchandiseIds.ADDON_WORKFLOWS
}), (0, _defineProperty2.default)(_GENERAL$SALES_PRO$SA, LISTS_ADDON, {
  upgradeLink: links.marketingPricing,
  merchandiseId: MerchandiseIds.ADDON_LISTS
}), (0, _defineProperty2.default)(_GENERAL$SALES_PRO$SA, CUSTOM_SSL, {
  upgradeLink: links.addonCustomSsl,
  merchandiseId: MerchandiseIds.ADDON_CUSTOM_SSL
}), (0, _defineProperty2.default)(_GENERAL$SALES_PRO$SA, DESIGNATED_TECHNICAL_SUPPORT, {
  upgradeLink: links.serviceDesignatedTechnicalSupport,
  merchandiseId: MerchandiseIds.SERVICE_DESIGNATED_TECHNICAL_SUPPORT
}), (0, _defineProperty2.default)(_GENERAL$SALES_PRO$SA, IN_PERSON_TRAINING, {
  upgradeLink: links.serviceInPersonTraining,
  merchandiseId: MerchandiseIds.SERVICE_INBOUND_CONSULTING_ONE_DAY
}), (0, _defineProperty2.default)(_GENERAL$SALES_PRO$SA, STARTER_KIT, {
  upgradeLink: links.serviceStarterKit,
  merchandiseId: MerchandiseIds.SERVICE_CRM_SALES_STARTER_KIT
}), (0, _defineProperty2.default)(_GENERAL$SALES_PRO$SA, SALES_PROFESSIONAL_ONBOARDING, {
  upgradeLink: links.salesProfessionalOnboarding,
  merchandiseId: MerchandiseIds.SERVICE_SALES_PROFESSIONAL_ONBOARDING
}), (0, _defineProperty2.default)(_GENERAL$SALES_PRO$SA, SERVICE_PROFESSIONAL_ONBOARDING, {
  upgradeLink: links.serviceProfessionalOnboarding,
  merchandiseId: MerchandiseIds.SERVICE_SERVICE_PROFESSIONAL_ONBOARDING
}), (0, _defineProperty2.default)(_GENERAL$SALES_PRO$SA, INBOUND_CONSULTING_BLOCK, {
  upgradeLink: links.inboundConsultingBlock,
  merchandiseId: MerchandiseIds.SERVICE_INBOUND_CONSULTING_FOUR_HOUR
}), (0, _defineProperty2.default)(_GENERAL$SALES_PRO$SA, TECHNICAL_CONSULTING_BLOCK, {
  upgradeLink: links.technicalConsultingBlock,
  merchandiseId: MerchandiseIds.SERVICE_TECH_CONSULTING_FOUR_HOURS
}), (0, _defineProperty2.default)(_GENERAL$SALES_PRO$SA, ENTERPRISE, {
  upgradeLink: links.marketingPricing,
  merchandiseId: null
}), (0, _defineProperty2.default)(_GENERAL$SALES_PRO$SA, CRM, {
  upgradeLink: links.addonCrm,
  merchandiseId: MerchandiseIds.PRODUCT_CRM
}), (0, _defineProperty2.default)(_GENERAL$SALES_PRO$SA, PARTNER_PROGRAM, {
  upgradeLink: links.partnerProgramPaywall,
  merchandiseId: null
}), (0, _defineProperty2.default)(_GENERAL$SALES_PRO$SA, SUITE_STARTER, {
  upgradeLink: links.suite,
  merchandiseId: null
}), (0, _defineProperty2.default)(_GENERAL$SALES_PRO$SA, SUITE_PROFESSIONAL, {
  upgradeLink: links.suite,
  merchandiseId: null
}), (0, _defineProperty2.default)(_GENERAL$SALES_PRO$SA, SUITE_ENTERPRISE, {
  upgradeLink: links.suite,
  merchandiseId: null
}), (0, _defineProperty2.default)(_GENERAL$SALES_PRO$SA, BUNDLE, {
  upgradeLink: links.bundle,
  merchandiseId: null
}), (0, _defineProperty2.default)(_GENERAL$SALES_PRO$SA, TEMPORARY_REMOTE_TOOLS, {
  upgradeLink: null,
  merchandiseId: null
}), (0, _defineProperty2.default)(_GENERAL$SALES_PRO$SA, MARKETING, {
  upgradeLink: links.marketingPricing,
  merchandiseId: null
}), (0, _defineProperty2.default)(_GENERAL$SALES_PRO$SA, SALES, {
  upgradeLink: links.salesPricing,
  merchandiseId: null
}), (0, _defineProperty2.default)(_GENERAL$SALES_PRO$SA, SERVICE, {
  upgradeLink: links.servicePricing,
  merchandiseId: null
}), _GENERAL$SALES_PRO$SA);

exports.default = _default;
module.exports = exports.default;